/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_SubInputs */

const en_cp_jr_sub = /** @type {(inputs: Cp_Jr_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compared with Bangkit, 1000 Startup Digital or Indigo, campuses need a cheap way to start and a clear next step. These four stages wrap the 14-week calendar.`)
};

const id_cp_jr_sub = /** @type {(inputs: Cp_Jr_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibanding program lain (Bangkit, 1000 Startup, Indigo), kampus butuh cara mulai yang murah dan tujuan lanjutan yang jelas. Empat langkah ini membungkus kalender 14 minggu.`)
};

/**
* | output |
* | --- |
* | "Compared with Bangkit, 1000 Startup Digital or Indigo, campuses need a cheap way to start and a clear next step. These four stages wrap the 14-week calendar." |
*
* @param {Cp_Jr_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_sub = /** @type {((inputs?: Cp_Jr_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_sub(inputs)
	return en_cp_jr_sub(inputs)
});